module.exports = __webpack_public_path__ + "img/register-v2-dark.ed0e6db4.svg";